import React from 'react'
import { toast } from 'react-toastify'
import { Typography } from '@mui/material'
import './styles.css'

export const feedback = (type, message = '', restProps) => {
  const ToastContent = ({ message }) => (
    <Typography variant="body1" display="inline">
      {message}
    </Typography>
  )

  switch (type) {
    case 'error':
      return toast.error(<ToastContent message={message} />, restProps)
    case 'success':
      return toast.success(<ToastContent message={message} />, restProps)
    case 'warning':
      return toast.warning(<ToastContent message={message} />, restProps)
    case 'info':
      return toast.info(<ToastContent message={message} />, restProps)
    default:
      console.error('Feedback Toaster: El tipo no está definido')
      return null
  }
}

export default feedback
